/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuMain() {
    const intl = useIntl()

    return (
        <>
        {/* <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} /> */}
            <AsideMenuItem
                to='/dashboard'
                icon='/media/icons/duotune/general/gen003.svg'
                title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
                fontIcon='bi-app-indicator'
            />
            {/* <AsideMenuItem
                to='/builder'
                icon='/media/icons/duotune/general/gen019.svg'
                title='Layout Builder'
                fontIcon='bi-layers'
            />
            <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                        Crafted
                    </span>
                </div>
            </div> */}

<AsideMenuItemWithSub
                to=''
                title='New Patient'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='IPD Reservation'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Patients/Guests'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItem to='/patients/list' title='Patients List' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Calendar'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Inquiries'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Panchkarma (Therapies)'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Therapy and Treatment Packages'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Membership Packages'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Account'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/finance/fin001.svg'
            >
                <AsideMenuItem to='#' title='Dashboard' hasBullet={true} />
                <AsideMenuItem to='#' title='Accounts' hasBullet={true} />
                <AsideMenuItem to='#' title='Reports' hasBullet={true} />
                <AsideMenuItem to='#' title='Settings' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Pharma Inventory'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItem to='pharma/medicinstock' title='Medicine Stock' hasBullet={true} />
                <AsideMenuItem to='pharma/addstock' title='Add Stock' hasBullet={true} />
                <AsideMenuItem to='pharma/medicinebills' title='Medicine Bills' hasBullet={true} />
                <AsideMenuItem to='pharma/suppliers' title='Supplier list' hasBullet={true} />
                <AsideMenuItem to='pharma/purchaseorder' title='Purchase Order' hasBullet={true} />
                <AsideMenuItem to='#' title='Compositions Stocks' hasBullet={true} />
                <AsideMenuItem to='#' title='Returns' hasBullet={true} />
                <AsideMenuItem to='#' title='Discarded Stock' hasBullet={true} />
                <AsideMenuItem to='pharma/medicine' title='Medicine' hasBullet={true} />
                <AsideMenuItem to='#' title='Settings' hasBullet={true} />
            </AsideMenuItemWithSub>
           
           
            {/* <AsideMenuItemWithSub
                to=''
                title='IPD Reservation'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub> */}
            
          
           
           
            <AsideMenuItemWithSub
                to='#'
                title='Billing'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItem to='#' title='Recent Patient/In-house Patients' hasBullet={true} />
                <AsideMenuItem to='#' title='Bill list' hasBullet={true} />
                <AsideMenuItem to='#' title='New Bill' hasBullet={true} />
                <AsideMenuItem to='#' title='Food Menu/Item Price List/Billable Items' hasBullet={true} />
                <AsideMenuItem to='#' title='Settings' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Couriers'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Store/F&B/Laundry/Housekeeping Inventory'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='HR'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/medicine/med002.svg'
            >
                <AsideMenuItem to='#' title='Inventory View' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Maintenance Request'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Share'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Feedback'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/medicine/med002.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Patient/Guest Communication'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Reports & Analytics'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='System Settings'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='My Account'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Subscription'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Wallet'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Support'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='#'
                title='Client Registration Wizard'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            

            {/* <AsideMenuItemWithSub
                to=''
                title='Pharmacy Bill'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                   <AsideMenuItem to='' title='Pharmacy Bill View' hasBullet={true} />
            </AsideMenuItemWithSub>
             
                <AsideMenuItemWithSub
                to=''
                title='IPD'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItem to='' title='IPD Patient' hasBullet={true} />
                <AsideMenuItem to='' title='Room Status' hasBullet={true} />
                <AsideMenuItem to='' title='Room Availiblity' hasBullet={true} />
                <AsideMenuItem to='' title='Tharepy Schedule' hasBullet={true} />
                <AsideMenuItem to='' title='Daily Medicine' hasBullet={true} />
                <AsideMenuItem to='' title='Todays Servings' hasBullet={true} />
                <AsideMenuItem to='' title='Laundry' hasBullet={true} />
                <AsideMenuItem to='' title='Store Inventory' hasBullet={true} />
                <AsideMenuItem to='' title='Reservations' hasBullet={true} />
                <AsideMenuItem to='' title='Other Bill' hasBullet={true} />

                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub
                to=''
                title='Clinic'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItem to='' title='Clinic List' hasBullet={true} />
                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub
                to=''
                title='Reports'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItem to='' title='Reports List' hasBullet={true} />
                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub
                to=''
                title='HR'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Wallet'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Subscription'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to=''
                title='Support'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
            </AsideMenuItemWithSub> */}
            <AsideMenuItemWithSub
                to=''
                title='Software Configuration'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItemWithSub to='/crafted/pages/profile' title='Diet' hasBullet={true}>
                    <AsideMenuItem
                        to='/configurations/diet/language'
                        title='Language'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/diet/category'
                        title='Food Categories'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/diet/items'
                        title='Food Items'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/diet/foodPreparation'
                        title='Food Preparations'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/diet/instructions'
                        title='Instructions'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/diet/dietPlan'
                        title='Meals'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/diet/dietChart'
                        title='Food Templates'
                        hasBullet={true}
                    />
                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub to='/crafted/pages/profile' title='Medicine' hasBullet={true}>
                    <AsideMenuItem
                        to='/configurations/medicine/Type'
                        title='Medicine Type'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Disease  Category'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/medicine/medicinelist'
                        title='Medicine List'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/medicine/allopethy'
                        title='Allopethy Medicine'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/medicine/medicinecompanylist'
                        title='Medicine Company List'
                        hasBullet={true}
                    />
                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub to='/crafted/pages/profile' title='Other' hasBullet={true}>
                    <AsideMenuItem
                        to='/configurations/other/users'
                        title='Users'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/consultationdepartment'
                        title='Consultation Department'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/courier'
                        title='Courier'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/therapy'
                        title='Therapy'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/therapyroom'
                        title='Therapy Room'
                        hasBullet={true}
                    />

                    <AsideMenuItem
                        to='/configurations/other/idproof'
                        title='ID Proof'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Package'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/expendituresubject'
                        title='Expenditure Subject'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/investigation'
                        title='Investigation'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Diseases followup'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/reference'
                        title='Reference'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/inquirytype'
                        title='Inquiry Type'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/saloncategory'
                        title='Salon Category'
                        hasBullet={true}
                    />
                    <AsideMenuItem to='/configurations/other/gst' title='GST' hasBullet={true} />
                    <AsideMenuItem
                        to='/configurations/other/salon'
                        title='Salon'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/extrachargesubject'
                        title='Extra Charge-Subject'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/persontype'
                        title='Person Type'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/laundryprice'
                        title='Laundry Price'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/other/department'
                        title='Department'
                        hasBullet={true}
                    />
                      <AsideMenuItem
                        to='/configurations/other/otcharge'
                        title='OT Charges'
                        hasBullet={true}
                    />
                      <AsideMenuItem
                        to='/configurations/other/storeitemcategory'
                        title='Store Item Category'
                        hasBullet={true}
                    />
                      <AsideMenuItem
                        to='/configurations/other/storeitemsubcategory'
                        title='Store Item Sub Category'
                        hasBullet={true}
                    />

                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub
                    to='/crafted/pages/profile'
                    title='Software configurations'
                    hasBullet={true}
                >
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Clinic Details'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Branch'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='SMS'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Email'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Print'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Basic Detail'
                        hasBullet={true}
                    />
                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub
                    to='/historyform/habit'
                    title='History Form'
                    hasBullet={true}
                >
                    <AsideMenuItem
                        to='/configurations/historyform/habit'
                        title='Habit'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/historyform/habitoption'
                        title='Habit Option'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/historyform/pasthistory'
                        title='Past History'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/historyform/prakrutisubcategory'
                        title='Prakruti Sub Category'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/configurations/historyform/prakrutioption'
                        title='Prakruti Option'
                        hasBullet={true}
                    />
                     <AsideMenuItem
                        to='/configurations/historyform/observation'
                        title='Observation'
                        hasBullet={true}
                    />
                     <AsideMenuItem
                        to='/configurations/historyform/observationoption'
                        title='Observation Option'
                        hasBullet={true}
                    />
                </AsideMenuItemWithSub>
                <AsideMenuItemWithSub to='/crafted/pages/profile' title='IPD' hasBullet={true}>
                    <AsideMenuItem
                        to='/configurations/ipd/category'
                        title='Category'
                        hasBullet={true}
                    />
                    {/* <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Category'
                        hasBullet={true}
                    /> */}
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Room'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Extra Charge - Subject'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='IPD - Package'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Laundry'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Food - Item'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Other'
                        hasBullet={true}
                    />
                </AsideMenuItemWithSub>
            </AsideMenuItemWithSub>
            
            {/* <AsideMenuItemWithSub
                to='/crafted/pages'
                title='Pages'
                fontIcon='bi-archive'
                icon='/media/icons/duotune/general/gen022.svg'
            >
                <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
                    <AsideMenuItem
                        to='/crafted/pages/profile/overview'
                        title='Overview'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/projects'
                        title='Projects'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/campaigns'
                        title='Campaigns'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/documents'
                        title='Documents'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/profile/connections'
                        title='Connections'
                        hasBullet={true}
                    />
                </AsideMenuItemWithSub>

                <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
                    <AsideMenuItem
                        to='/crafted/pages/wizards/horizontal'
                        title='Horizontal'
                        hasBullet={true}
                    />
                    <AsideMenuItem
                        to='/crafted/pages/wizards/vertical'
                        title='Vertical'
                        hasBullet={true}
                    />
                </AsideMenuItemWithSub>
            </AsideMenuItemWithSub> */}
            {/* <AsideMenuItemWithSub
                to='/crafted/accounts'
                title='Accounts'
                icon='/media/icons/duotune/communication/com006.svg'
                fontIcon='bi-person'
            >
                <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
                <AsideMenuItem to='/crafted/account/configurations' title='configurations' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='/error'
                title='Errors'
                fontIcon='bi-sticky'
                icon='/media/icons/duotune/general/gen040.svg'
            >
                <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
                <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
                to='/crafted/widgets'
                title='Widgets'
                icon='/media/icons/duotune/general/gen025.svg'
                fontIcon='bi-layers'
            >
                <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
                <AsideMenuItem
                    to='/crafted/widgets/statistics'
                    title='Statistics'
                    hasBullet={true}
                />
                <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
                <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
                <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
                <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
            </AsideMenuItemWithSub>
            <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
                </div>
            </div>
            <AsideMenuItemWithSub
                to='/apps/chat'
                title='Chat'
                fontIcon='bi-chat-left'
                icon='/media/icons/duotune/communication/com012.svg'
            >
                <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
                <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
                <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItem
                to='/apps/user-management/users'
                icon='/media/icons/duotune/general/gen051.svg'
                title='User management'
                fontIcon='bi-layers'
            />
            <div className='menu-item'>
                <div className='menu-content'>
                    <div className='separator mx-1 my-4'></div>
                </div>
            </div>
            <div className='menu-item'>
                <a
                    target='_blank'
                    className='menu-link'
                    href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
                >
                    <span className='menu-icon'>
                        <KTSVG
                            path='/media/icons/duotune/general/gen005.svg'
                            className='svg-icon-2'
                        />
                    </span>
                    <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
                </a>
            </div> */}
        </>
    )
}
